import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import debounce from 'debounce'

import {
    Card,
    Table,
    Row,
    Col,
    Button,
    Popconfirm,
    Badge,
    Input,
} from 'antd'

import {
    _postSearchCreditApplication,
    _postRejectCreditApplication,
    _postApproveCreditApplication,
} from '../../services';

import './index.css'

import ApprovalModal from './approval-modal';

const APPROVAL_STATUS = {
	PENDING: 'PENDING',
	APPROVED: 'APPROVED',
	REJECTED: 'REJECTED'
}

class CreditApproval extends React.Component {

    constructor(props) {
        super(props) 
        this.state = {
            searchTerm: '',
            page: 1,
            limit: 10,
            count: 0,
            creditApplications: [],
            approvalStatusFilter: [],
            loading: true,

            modalVisible:  false,
        }

        this.setSearch = debounce(this.setSearch, 400)
    }

    render() {

        return(
            <Card
            title={
                <Row type="flex" justify="space-between">
                    <Col>
                        Credit Approval
                    </Col>
                    <Col>
                        <Input
                            style={{ width: 400, marginBottom: 0, marginRight: 'auto' }}
                            placeholder="Search Company Name"
                            onChange={this.handleSearch}
                        />
                    </Col>
                </Row>
            }
            >
                {this.renderTable()}

                {this.state.modalVisible && 
                <ApprovalModal 
                    visible= {this.state.modalVisible}
                    activeEnterprise= {this.state.activeEnterprise}

                    closeModal= {() => this.setState({modalVisible: false})}
                    approveCreditApplication={this.approveCreditApplication}
                    />
                }
            </Card>
        )
    }

    componentDidMount() {
        this.getCreditApplications()
    }

    getCreditApplications = () => {

        const { searchTerm, page, limit, approvalStatusFilter } = this.state

        this.setState({loading: true})

        _postSearchCreditApplication({
            searchTerm,
            page,
            limit,
            approvalStatusFilter
        })
        .then(res => {
            this.setState({
                creditApplications: res.data._enterprises.docs,
                count: res.data._enterprises.count,
                loading: false,
            })
        })
    }

    renderTable = () => {

        const columns = [{
            title: 'Company Name',
            dataIndex: 'companyName'
        }, {
            title: 'Credit Limit',
            dataIndex: 'creditLimit'
        }, {
            title: 'Term Days',
            dataIndex: 'creditTermDays'
        }, {
            title: 'Date',
            dataIndex: 'dateCreated',
            render: (dateCreated) => moment(dateCreated).format('MMMM DD, YYYY h:mm A')
        }, {
            title: 'Approval Status',
            dataIndex: 'approvalStatus',
            render: (approvalStatus) => {
                if (approvalStatus == APPROVAL_STATUS.PENDING) {
                    return <Badge text={approvalStatus} status={'default'} />
                }
                if (approvalStatus == APPROVAL_STATUS.APPROVED) {
                    return <Badge text={approvalStatus} status={'success'} />
                }
                if (approvalStatus == APPROVAL_STATUS.REJECTED) {
                    return <Badge text={approvalStatus} status={'error'} />
                }
            },
            filters: Object.values(APPROVAL_STATUS).map((_approvalStatus) => ({ text: _approvalStatus, value: _approvalStatus} )),
            filteredValue: this.state.approvalStatusFilter
        },{
            title: 'Documents',
            dataIndex: 'webViewLink',
            render: (webViewLink) => (
            <div>
                <a href={webViewLink.creditApplication} target="_blank" className="document-button">Form</a>
                {webViewLink.additionalInfo!='false' && 
                <a href={webViewLink.additionalInfo} target="_blank" className="document-button">ACRA</a>
                }
            </div>
            )
        },{
            title: 'Actions',
            dataIndex: '_id',
            render: (_id, record) => this.renderActions(_id, record)
        }]

        const { loading, creditApplications, page, limit, count } = this.state

        return (

            <Table
                loading={loading}
                pagination={{
                    current: page,
                    pageSize: limit,
                    total: count,
                    onChange: (nextPage)=>this.setState({ page: nextPage }, this.getCreditApplications)
                }}
                onChange={this.handleTableChange}
                columns={columns}
                dataSource={creditApplications}
                rowKey="_id"
                size="medium"
            />

        )
    }

    renderActions = (_id, record) => {

        if (record.approvalStatus == APPROVAL_STATUS.PENDING) {
            
            return (
                <div>
                    {/* Approve */}
                    <Button
                        type="primary"
                        style={{marginLeft: 8}}
                        onClick={()=>this.setState({ 
                            modalVisible: true,
                            activeEnterprise: record
                        })}
                        >
                        Approve</Button>
    
                    {/* Reject */}
                    <Popconfirm
                        title="Confirm Reject Application?"
                        onConfirm={()=>this.rejectCreditApplication(record._id)}
                        okText="Yes"
                        cancelText="No"
                        >
                        <Button
                            type="danger"
                            style={{marginLeft: 8}}
                            onClick={()=>this.setState({ readOnly: false})}
                            >
                            Reject</Button>
                    </Popconfirm>
                </div>
            )
        }
        return (
            <p style={{marginBottom: '0px'}}>{(record.createdBy && record.createdBy.name) || ''}</p>
        )
    }

    rejectCreditApplication = (enterpriseId) => {
        console.log('reject Credit Application!')
        _postRejectCreditApplication({
            enterpriseId,
            approver: this.props.user.data
        })
        .then(res => {
            console.log(res)
            this.getCreditApplications()
        })
    }
    
    approveCreditApplication = ({enterpriseId, creditLimit, creditTermDays}) => {
        console.log('approve Credit Application!')
        _postApproveCreditApplication({
            enterpriseId,
            creditLimit,
            creditTermDays,
        })
        .then(res => {
            console.log(res)
            this.getCreditApplications()
        })
    }

    handleSearch = (e) => {
        this.setSearch(e.target.value)
    }

    setSearch = (searchTerm) => {
        this.setState({
            searchTerm
        }, this.getCreditApplications)
    }

    handleTableChange = (pagination, filters, sorter, extra) => {

        this.setState({
            approvalStatusFilter: filters.approvalStatus
        }, this.getCreditApplications)
    }

}

// export default CreditApproval;

export default connect(
    state => ({
        user: state.user
    })
)(CreditApproval);


// WEBPACK FOOTER //
// ./src/components/credit-approval/index.js